import { useContext } from 'react';
import { SubstraHooksContext } from '../providers/substrahooks-provider/context';
export const useApiProvider = (apiProviderId) => {
    var _a;
    const defaultId = useContext(SubstraHooksContext).defaultApiProviderId;
    return (_a = useContext(SubstraHooksContext).apiProviders[apiProviderId || defaultId]) === null || _a === void 0 ? void 0 : _a.apiProvider;
};
//# sourceMappingURL=use-api-provider.js.map